import { tracking } from '@bark/bark-core';

export const showQuickFilters = () => $('#__rctLeadsQuickFilters').length;

export const isQuickFiltersLoaded = () => $(`#__rctLeadsQuickFilters`).children().length;

export let QuickFiltersRctDispatcher = null;

export function updateQuickFiltersRct() {
	if (!isQuickFiltersLoaded()) {
		window.SellerAppDashboard.launchModule(
			'leads-quick-filters',
			'__rctLeadsQuickFilters',
			{
				onClickQuickFilter: onSelectQuickFilter,
				onMount: (dispatch) => {
					QuickFiltersRctDispatcher = dispatch;
					setQuickFiltersRctState();
				},
			},
		);
	} else {
		setQuickFiltersRctState();
	}
}

export function setQuickFiltersRctState() {
	if (QuickFiltersRctDispatcher) {
		QuickFiltersRctDispatcher({
			type: 'setQuickFilters',
			value: buildQuickFilters(),
		});
	}
}

export const buildQuickFilters = () => {
	const filterKeys = [
		'suggested-features-free_leads',
		'suggested-features-no_responses',
		'suggested-features-is_urgent'
	];
	const newFilters = [
		'suggested-features-free_leads',
	];
	const icons = {
		'suggested-features-free_leads': 'https://www.bark.com/resources/icons/elite_pro.svg'
	}
	const quickFilters = [];
	filterKeys.forEach((filterKey) => {
		const element = getFilterInputElement(filterKey);
		if (element.length) {
			const quickFilterData = {
				filterKey: filterKey,
				filterLabel: getFilterLabelText(filterKey),
				isActive: getFilterIsActive(filterKey),
				isDisabled: getFilterIsDisabled(filterKey),
				isNew: newFilters.includes(filterKey),
				icon: icons[filterKey],
			};
			quickFilters.push(quickFilterData);
		}
	});
	return quickFilters;
};

export const onSelectQuickFilter = (quickFilter) => {
	tracking('quick-filters-leads-list', 'filter-click', {
		seller_profile_id: Bark?.seller?.id,
		quick_filter_value: quickFilter.filterKey,
	});

	const $filterInputElement = getFilterInputElement(quickFilter.filterKey);
	$filterInputElement.trigger('click');
	$('#dashboard-sidebar-modal .filter-results').trigger('click');

	const filterIsActive = getFilterIsActive(quickFilter.filterKey);
	if (
		filterIsActive &&
		!Bark.seller.quickFiltersApplied.includes(quickFilter.filterKey)
	) {
		Bark.seller.quickFiltersApplied.push(quickFilter.filterKey);
	}
	if (
		!filterIsActive &&
		Bark.seller.quickFiltersApplied.includes(quickFilter.filterKey)
	) {
		Bark.seller.quickFiltersApplied.splice(
			Bark.seller.quickFiltersApplied.indexOf(quickFilter.filterKey),
			1,
		);
	}
};

const getFilterInputElement = (filterKey) =>
	$(`.sidebar-content-wrapper #filter-input-${filterKey}`);

const getFilterLabelText = (filterKey) => {
	const $filterInputElement = getFilterInputElement(filterKey);
	return $filterInputElement
		.closest('.custom-control')
		.find('.custom-control-label')
		.text();
};
const getFilterIsActive = (filterKey) => {
	const $filterInputElement = getFilterInputElement(filterKey);
	return $filterInputElement.is(':checked');
};
const getFilterIsDisabled = (filterKey) => {
	const $filterInputElement = getFilterInputElement(filterKey);
	return $filterInputElement.is(':disabled');
};
